import React from 'react';

const MapPinIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none">
    <g>
      <path
        d="M7.99967 9.16626C7.99967 9.8293 8.26307 10.4652 8.73191 10.934C9.20075 11.4029 9.83663 11.6663 10.4997 11.6663C11.1627 11.6663 11.7986 11.4029 12.2674 10.934C12.7363 10.4652 12.9997 9.8293 12.9997 9.16626C12.9997 8.50322 12.7363 7.86733 12.2674 7.39849C11.7986 6.92965 11.1627 6.66626 10.4997 6.66626C9.83663 6.66626 9.20075 6.92965 8.73191 7.39849C8.26307 7.86733 7.99967 8.50322 7.99967 9.16626Z"
        stroke="#475467"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2138 13.8806L11.678 17.4164C11.3655 17.7286 10.9418 17.904 10.5001 17.904C10.0584 17.904 9.63469 17.7286 9.32218 17.4164L5.78551 13.8806C4.8532 12.9482 4.21829 11.7603 3.96108 10.4671C3.70388 9.17394 3.83592 7.83352 4.34051 6.61536C4.84511 5.39721 5.69959 4.35604 6.79591 3.62351C7.89223 2.89098 9.18115 2.5 10.4997 2.5C11.8182 2.5 13.1071 2.89098 14.2034 3.62351C15.2998 4.35604 16.1542 5.39721 16.6588 6.61536C17.1634 7.83352 17.2955 9.17394 17.0383 10.4671C16.7811 11.7603 16.1462 12.9482 15.2138 13.8806Z"
        stroke="#475467"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default MapPinIcon;
